<script>
import classModifierMixin from './mixins/class-modifier-mixin'
export default {
	name: 'BaseLabel',
	mixins: [classModifierMixin],
	props: {
		value: String,
		forElement: String
	}
}
</script>

<template>
	<label :for="forElement" class="base-label" :class="modifierClasses">
		{{value}}
	</label>
</template>

<style lang="scss">
.base-label {
    background-color: var(--background-variant-dark);
    color: (--on-background);
	font-size: var(--font-size-caption);
	font-weight: var(--font-weight-body-1);
	padding: 0.1rem 0.6rem;
	&--height-25 {
		margin: auto 0;
		max-height: 25px;
		max-width: max-content;
		width: 100%;
	}
	&--required {
		background-color: var(--required-label-bg-colour);
		color: var(--required-label-text-colour);
	}
	&--optional {
		background-color: var(--optional-label-bg-colour);
		color: var(--optional-label-text-colour);
	}
	&--danger {
		background-color: var(--danger-colour);
		color: (--on-danger);
		margin: auto 0;
		max-height: 25px;
		max-width: max-content;
		width: 100%;
	}
	&--bold {
		font-weight: bold;
	}
	&--margin-r {
		margin-right: 0.5rem;
	}
}
</style>
